import {
  CartSettings,
  InjectedCartProps,
  withCartFactory,
} from '@grandvisionhq/www-next/pages/cart/hoc'

import { deliveryResolverFactory } from '../../util/delivery-resolver-factory'

export const settings: CartSettings = {
  deliveryResolverFactory,
  maximumQuantity: 10,
  isDiscountCodeEnabled: true,
  shouldShowCartDiscountOnLineItem: false,
  shouldShowShippingMethod: true,
  shouldShowSubTotal: true,
  shouldShowTotalDiscount: true,
  isMultiDiscountType: true,
  shouldHideStockAndDeliveryOnLineItem: true,
  onFinalizedCartError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
  onUnRecoverableError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
